import styled from 'styled-components'
import { Typography, Input } from 'antd'
import { SPACING, COLORS, MEDIA, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

const { Title } = Typography

/**
 * Styled components for DashboardHeader
 */

// Wrapper for entire header section
export const HeaderWrapper = styled.div`
  margin-top: 36px;
  margin-bottom: ${SPACING.lg};

  ${MEDIA.mobile} {
    margin-top: ${SPACING.lg};
  }
`

// Page title with no margin
export const PageTitle = styled(Title)`
  && {
    margin: 0;

    ${MEDIA.mobile} {
      font-size: ${TYPOGRAPHY.h4.fontSize};
      line-height: 1.3;
    }
  }
`

// Container for search and create button - pushed to right of tabs row
export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.md};
  margin-left: auto;
  margin-bottom: ${SPACING.sm};

  ${MEDIA.mobile} {
    order: -1;
    width: 100%;
    margin-left: 0;
    margin-bottom: 0;
    padding-bottom: ${SPACING.md};
  }
`

// Search input
export const SearchInput = styled(Input)`
  && {
    width: 200px;

    ${MEDIA.mobile} {
      flex: 1;
      width: auto;
      min-width: 0;
    }
  }
`

// Tabs row - underlined tab style with search on right
export const TabsRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${SPACING.lg};
  margin-top: ${SPACING.lg};
  border-bottom: 1px solid ${COLORS.borderLight};

  ${MEDIA.mobile} {
    flex-wrap: wrap;
  }
`

// Individual tab with underline indicator
export const Tab = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  padding: ${SPACING.sm} ${SPACING.xs};
  padding-bottom: ${SPACING.md};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  cursor: pointer;
  position: relative;
  color: ${({ $active }) => ($active ? COLORS.textPrimary : COLORS.textSecondary)};
  transition: color 0.2s ease;

  &:hover {
    color: ${COLORS.textPrimary};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: ${({ $active }) => ($active ? COLORS.primary : 'transparent')};
    border-radius: 2px 2px 0 0;
    transition: background-color 0.2s ease;
  }
`
